export enum EDealRequestCommunicationType {
  Phone = "Phone",
  Messenger = "Messenger",
}

export enum EDealRequestTimeInterval {
  From9AMTo6PMWorkday = "From9AMTo6PMWorkday",
  From6PMTo9PMWorkday = "From6PMTo9PMWorkday",
  From11AMTo8PMWeekend = "From11AMTo8PMWeekend",
  AnyTime = "AnyTime",
}

export enum EDealRequestViewType {
  WithRealtor = "WithRealtor",
  WithoutRealtor = "WithoutRealtor",
  OnlyRealtor = "OnlyRealtor",
}

export enum EPurchasePurpose {
  IncreaseArea = "IncreaseArea",
  DecreaseArea = "DecreaseArea",
  ChangeLocation = "ChangeLocation",
  PurchaseForChildren = "PurchaseForChildren",
  Split = "Split",
}

export enum EReadinessForLowerSellPrice {
  Any = "Any",
  UpTo5Percent = "UpTo5Percent",
}

export enum ESideDeal {
  Seller = "Seller",
  Purchaser = "Purchaser",
  Realtor = "Realtor",
}

export enum ESpecificsOfSale {
  maternityCapital = "MaternityCapital",
  encumbrance = "Encumbrance",
  childrenOwn = "ChildrenOwn",
  privatization = "Privatization",
  arrest = "Arrest",
  debt = "Debt",
}

export interface ICounterPage {
  current: number;
  max: number;
}
